/*
    This block is to handle Mailchimp select fields, to style as per new design select fields
    have to be wrapped in a div to allow styling of the element (selects are heavly controlled
    by the OS). Mailchimp adds error classes to the select when it needs to be added to the 
    parent div to style it properly. This code will watch for the mailchip error classes
    and also write them to the parent div.
*/
(function ($) {
    'use strict';
    $(document).ready(function () {
        //Find all form selects that are wrap with the form select class used by mailchimp
        var targets = $('#mc_embed_signup form .ncver-form__select select');

        //No form targets
        if (targets.length > 0) {
            // create an observer instance
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.attributeName === 'class') {
                        var attributeValue = $(mutation.target).prop(mutation.attributeName);

                        if (attributeValue.indexOf('mce_inline_error') > -1) {
                            $(mutation.target).parent().addClass('mce_select_inline_error');
                        } else {
                            $(mutation.target).parent().removeClass('mce_select_inline_error');
                        }
                    }
                });
            });

            // configuration of the observer, only care about classes
            var config = { attributes: true };

            //Watch all our targets
            targets.each(function () {
                observer.observe(this, config);
            });
        }
    });
}(jQuery));

/*
    This sets up the validation for the AVETMISS Support Contact Form
*/
(function ($) {
    'use strict';
    $(document).ready(function () {
        var contactForm = $('.AVETMISS-Support-Contact-Form').closest('form');
        var validator = contactForm.validate({
            errorPlacement: function (error, element) {
                //If element is a ncver select, place the error on its parent 'ncver-form__element'
                if (element.parent().hasClass('ncver-form__select')) {
                    error.appendTo(element.parent().parent());
                } else {
                    //Otherwise just use its direct parent element
                    error.appendTo(element.parent());
                }
            },
            /*
                Custom error highlighting to apply to parent if element is a
                select field, otherwise directly to the element
            */
            highlight: function (element, errorClass, validClass) {
                element = $(element);
                if (element.parent().hasClass('ncver-form__select')) {
                    element.parent().removeClass(validClass);
                    element.parent().addClass(errorClass);
                } else {
                    element.removeClass(validClass);
                    element.addClass(errorClass);
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                element = $(element);
                if (element.parent().hasClass('ncver-form__select')) {
                    element.parent().removeClass(errorClass);
                    element.parent().addClass(validClass);
                } else {
                    element.removeClass(errorClass);
                    element.addClass(validClass);
                }
            },
            /*
                Custome messages for errors
            */
            messages: {
                "q47094:q1" : 'Name must not be empty',
                "q47094:q2" : 'Email address must not be empty',
                "q47094:q3" : 'Phone number must not be empty',
                "q47095:q1" : 'Organisation name must not be empty',
                "q47095:q2" : 'An Organisation type must be selected',
                //"q47095:q3" : '',
                //"q47095:q4" : '',
                //"q47095:q6" : '',
                "q47125:q1" : 'Issue/Query description must not be empty'
            }
        });

        $("#form_email_47030_reset").click(function() {
            validator.resetForm();
        });

        /*
            Re-use existing show hide logic for drop downs
        */
        if (contactForm.length > 0) {
            $("select").change(function () {
                $(this).find("option:selected").each(function () {
                    if ($(this).attr("value") == "RTO") {
                        $(".ncver-form__element--hidden").not(".red").hide();
                        $(".red").show();
                    } else if ($(this).attr("value") == "Other") {
                        $(".ncver-form__element--hidden").not(".green").hide();
                        $(".green").show();
                    }
                });
            }).change();

            $("select").change(function () {
                $(this).find("option:selected").each(function () {
                    if ($(this).attr("value") == "RTO Prov Other") {
                        $(".ncver-form__element--hidden").not(".green").hide();
                        $(".ncver-form__element--hidden").not(".red").hide();
                        $(".aqua").show();
                    }

                });
            }).change();
        }
    });
}(jQuery));